import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TicketArtSelectPage } from './ticket-art-select.page';

const routes: Routes = [
  {
    path: '',
    component: TicketArtSelectPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TicketArtSelectPageRoutingModule {}
